import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";

const BlogPost = ({ title, subText, date, link }) => {
  return (
    <>
      <Link to={link} style={{ textDecoration: "none", color: "black" }}>
        <div className="blog-post-item">
          <h1>{title}</h1>
          <p className="blog-subText">{subText}</p>
        </div>
      </Link>
      <Divider textAlign="right">{date}</Divider>
    </>
  );
};

export default BlogPost;
